<template>
  <RadioGroup
    v-model="radioValue"
    @change="handleChange"
    shape="dot"
    class="app-radio"
    :disabled="disabled"
  >
    <div v-for="(item, index) in data.optionsList" :key="index" class="radio-item">
      <Radio :name="item.id ? item.id : item.optionContent" checked-color="rgb(215, 0, 15)">{{
        item.optionContent
      }}</Radio>
      <Field
        v-if="item.othersFlag === '1' && otherInputValue"
        v-model="otherValue"
        show-word-limit
        :maxlength="500"
        :placeholder="data.remind"
        @blur="handleChange"
      />
    </div>
  </RadioGroup>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { Field, RadioGroup, Radio } from 'vant'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: ''
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const radioValue = ref(props.value)

const otherValue = ref('')

const otherInputValue = computed(() => {
  return props.data.optionsList.some(item => {
    if (item.id) {
      return item.id === radioValue.value && item.othersFlag === '1'
    } else {
      return item.optionContent === radioValue.value && item.othersFlag === '1'
    }
  })
})

// 暂定入参
const handleChange = () => {
  const str = {
    optionId: radioValue.value,
    otherContent: otherInputValue.value ? otherValue.value : '',
    othersFlag: otherInputValue.value ? '1' : undefined
  }
  emit('change', radioValue.value ? [str] : [])
}
onMounted(async () => {
  if (props.data.fieldValue) {
    radioValue.value = props.data.fieldValue[0].optionId
    otherValue.value = props.data.fieldValue[0].otherContent
      ? props.data.fieldValue[0].otherContent
      : undefined
  }
})
</script>

<style lang="less" scoped>
.app-radio {
  width: 100%;
  .radio-item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    :deep(.van-radio) {
      min-height: 40px;
      .van-radio__label {
        color: rgba(0, 0, 0, 0.7) !important;
      }
    }
  }
  .van-field {
    padding: 2px 8px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.04);
    margin-top: 8px;
  }
}
:deep(.van-field__word-limit) {
  border-bottom: none !important;
  padding-bottom: 0 !important;
}
</style>
